export const QUOTATION_REMOVE_PRODUCT = '/proposal/remove/quotation/item'
